

export enum SessionLecturerState {
  PRESENT = 'PRESENT',
  ABSENT = 'ABSENT'
};
